<template>
  <b-modal
    id="modal-filter"
    ok-title="Submit"
    cancel-variant="outline-secondary"
    title="過瀘"
    title-class="font-weight-bolder"
    body-class="common_modal p-2 modal_visible"
    hide-header
    hide-footer
    no-close-on-backdrop
    size="md"
    hide-header-close
  >
    <feather-icon
      @click="hide"
      style="position: absolute; right: 20px; top: -40px"
      size="18"
      icon="XIcon"
    />
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-form class="mt-1" @submit.prevent="onSubmit">
        <b-row>
          <b-col cols="12">
            <b-form-group
              label="發票："
              label-for="filter_invoice_id"
              label-cols-md="3"
            >
              <v-select
                id="filter_invoice_id"
                v-model="update.filter_invoice_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="invoiceOptions"
                label="invoice_number"
                :reduce="(option) => option.id"
                placeholder="選擇發票"
                :filter="invoiceSearch"
              >
                <template #option="{ invoice_number, name_cn, address }">
                  [{{ invoice_number }}] {{ name_cn || '未指定客戶' }}{{ address ? ' ' + address : '' }}
                </template>
                <template #selected-option="{ invoice_number, name_cn, address }">
                  [{{ invoice_number }}] {{ name_cn || '未指定客戶' }}{{ address ? ' ' + address : '' }}
                </template>
              </v-select>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group
              label="計薪形式："
              label-for="filter_salary_type"
              label-cols-md="3"
            >
              <v-select
                id="filter_salary_type"
                v-model="update.filter_salary_type"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="salaryTypeOptions"
                label="name"
                :reduce="(option) => option.value"
                placeholder="選擇計薪形式"
              >
              </v-select>
            </b-form-group>
          </b-col>
          <b-col cols="12" v-if="(ability.can('admin', 'user_salaries') && is_user_page) || (ability.can('read', 'salaries') && !is_user_page)">
            <b-form-group
              label="員工："
              label-for="filter_user_id"
              label-cols-md="3"
            >
              <v-select
                id="filter_user_id"
                v-model="update.filter_user_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="userOptionsWithAll"
                label="name_cn"
                :reduce="(option) => option.id"
                placeholder="選擇員工"
                :filter="userSearch"
              >
                <template #option="{ roles, name_cn }">
                  <template v-if="roles && roles[0]">
                    [{{ roles[0].name }}] {{ name_cn }}
                  </template>
                  <template v-else>
                    {{ name_cn }}
                  </template>
                </template>
                <template #selected-option="{ roles, name_cn }">
                  <template v-if="roles && roles[0]">
                    [{{ roles[0].name }}] {{ name_cn }}
                  </template>
                  <template v-else>
                    {{ name_cn }}
                  </template>
                </template>
              </v-select>
            </b-form-group>
          </b-col>
        </b-row>
        <div class="d-flex mt-2 justify-content-end">
          <!-- type="reset" -->
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="resetFilters"
            class="mr-1"
          >
            重置
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="button"
            variant="outline-danger"
            class="mr-1"
            @click="hide"
          >
            取消
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            type="submit"
          >
            <feather-icon size="16" class="mr-1" icon="CheckCircleIcon" />
            提交
          </b-button>
        </div>
      </b-form>
    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BButton,
  BModal,
  VBModal,
  BCardText,
  BOverlay,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BCard,
  BCardBody,
  BFormCheckbox,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import flatPickr from "vue-flatpickr-component";
import ability from "@/libs/acl/ability";
export default {
  components: {
    BButton,
    BModal,
    VBModal,
    BCardText,
    BOverlay,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCardBody,
    BCard,
    BFormCheckbox,
    vSelect,
    flatPickr,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  props: {
    userOptions: {
      type: Array,
      required: true,
    },
    filter_user_id: {},
    invoiceOptions: {
      type: Array,
      required: true,
    },
    filter_invoice_id: {},
    filter_salary_type: {},
    is_user_page: {},
  },
  data() {
    return {
      ability,
      loading: false,
      update: {
        filter_user_id: null,
        filter_invoice_id: null,
        filter_salary_type: null,
      },
      salaryTypeOptions: [
        { name: '全部', value: null },
        { name: '日薪', value: 1 },
        { name: '月薪', value: 2 },
        { name: '以工程項目計算', value: 3 },
      ],
    };
  },
  mounted() {
    // 同步當前的篩選器值到模態框
    this.update.filter_user_id = this.filter_user_id;
    this.update.filter_invoice_id = this.filter_invoice_id;
    this.update.filter_salary_type = this.filter_salary_type;
  },
  computed: {
    userOptionsWithAll() {
      const allOption = { id: -1, name_cn: '所有員工', roles: [{ name: '全部' }] };
      const targetOption = this.userOptions.filter(user => (user.user_type_id == 1 || user.user_type_id == 4));
      return [allOption, ...targetOption];
    }
  },
  methods: {
    hide() {
      this.$bvModal.hide("modal-filter");
    },
    resetFilters() {
      this.update = {
        filter_user_id: -1, // 重置為「所有員工」
        filter_invoice_id: null,
        filter_salary_type: null,
      };
    },
    invoiceSearch(options, search) {
      return options.filter((item) => {
        return item.invoice_number.toLowerCase().includes(search.toLowerCase());
      });
    },
    userSearch(options, search) {
      return options.filter((item) => {
        return item.name_cn.toLowerCase().includes(search.toLowerCase());
      });
    },
    onSubmit() {
      this.$emit("update:filter_user_id", this.update.filter_user_id);
      this.$emit("update:filter_invoice_id", this.update.filter_invoice_id);
      this.$emit("update:filter_salary_type", this.update.filter_salary_type);
      this.hide();
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
